import React from "react";
import { IntlProvider } from "react-intl";
import ReactDOM from "react-dom/client";
import { QueryClientProvider, QueryClient } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { ToastProvider } from "@panwds/react-ui";
import { GlobalFilterProvider } from "@panwds/react-filters";

import "@panwds/tailwindcss/palo.min.css";
import "./scss/app.scss";

import StatusPage from "./features/status/StatusPage";

const root = ReactDOM.createRoot(
    document.getElementById("sase-status-page-root"),
);

const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            retry: false,
            refetchOnWindowFocus: false,
            staleTime: 5 * 60 * 1000,
        },
    },
});

const StatusPageRoutes = () => {
    return (
        <Routes>
            <Route path="/" element={<StatusPage />} />
            <Route path="/:tab/*" element={<StatusPage />} />
        </Routes>
    );
};

root.render(
    <React.StrictMode>
        <BrowserRouter>
            <QueryClientProvider client={queryClient}>
                <GlobalFilterProvider>
                    <IntlProvider defaultLocale="en-US" locale="en-US">
                        <ToastProvider>
                            <StatusPageRoutes />
                        </ToastProvider>
                    </IntlProvider>
                </GlobalFilterProvider>
                <ReactQueryDevtools initialIsOpen={false} />
            </QueryClientProvider>
        </BrowserRouter>
    </React.StrictMode>,
);
